import { Component, OnInit,ViewChild,AfterViewInit } from '@angular/core';
import { FrontOffService,MasterService } from '../../services/index';

import { AppGlobals } from '../../shared/app.global';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';


import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-stuallocation',
  templateUrl: './stuallocation.component.html',
  styleUrls: ['./stuallocation.component.scss'],
    providers:[FrontOffService,AppGlobals,MasterService]
})
export class StuallocationComponent implements OnInit {

  
   //=[{'id':'1','name':'English'},{'id':'2','name':'Hindi'}];
   tab1=1;
   

 
 closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  arrrmcat: any=[];
  arrbilding: any=[];
  arrhosstu: any=[];
  buid:any;
  selstudent:any={};
  arflstudent: any=[];
 
 dropdownSettings:IDropdownSettings = {singleSelection: false,
       idField: 'stuid',
       textField: 'stunm',
       selectAllText: 'Select All',
       unSelectAllText: 'UnSelect All',
       itemsShowLimit: 0,
       allowSearchFilter: true};
  selected: any;
  rmctid: any;
  arrbeds: any;
  objbed: any={};
  fserdt: any;
  fserdt4: any;
  admdash: any;
   constructor(private http: HttpClient, private mservice:MasterService,private fservice: FrontOffService,private modalService: NgbModal,private apglobal:AppGlobals) {
 
   
    }
 
  
 
  
 
     
 
   ngOnInit(): void {
    
 this.getstudents();
    
    
   
 
   }
  
 
 
 gethomrmcat()
  {
    debugger
    this.mservice.gethomrmcat()
    .subscribe(
      
     resultArray =>{
      console.log('result',resultArray) ;
      //this.clsdate=resultArray;
      this.arrrmcat = resultArray;
      this.objbed.rmctid=this.arrrmcat[0].rmctid;
      this.getbeds(this.objbed.rmctid,this.objbed.buid);
      },
     error => console.log("Error :: " + error)
  )
  }
 
    getdatetoday() {
    this.fservice.getsysdatetoday()
        .subscribe(
        resultArray => {
            console.log('getlibsource', resultArray);
            this.objbed.stdt = resultArray;
            this.objbed.endt = resultArray;
            this.objbed.rarmk = '';
            // this.recdt = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }
    gethombuilding()
  {
    debugger
    this.mservice.gethombuilding()
    .subscribe(
      
     resultArray =>{
      console.log('result',resultArray) ;
      //this.clsdate=resultArray;
      this.arrbilding =  resultArray;
      this.objbed.buid=this.arrbilding[0].buid;
      this. gethomrmcat();
      },
     error => console.log("Error :: " + error)
  )
  }



  getstudents() {
  this.fservice.gethosstudents()
      .subscribe(
      resultArray => {
          console.log('getlibdepartment', resultArray);
          this.arrhosstu = resultArray.stulst;
          this.admdash=resultArray.studash;
        
          
      },
      error => console.log("Error :: " + error)
      )
}

getbeds(catid,buid) {
  this.fservice.getbedsbycat(catid,buid)
      .subscribe(
      resultArray => {
          console.log('getlibdepartment', JSON.stringify( resultArray));
          this.arrbeds = resultArray.roomsData;
        
          
      },
      error => console.log("Error :: " + error)
      )
}
 openmemdialog(content,formdata,cmd) {
   console.log("formdata",formdata);
 this.getdatetoday();
  this.gethombuilding();
  this.objbed.stuid=formdata;
  this.objbed.bdid='0';
   this.modalOptions = {
     backdrop:'static',
     backdropClass:'customBackdrop',
     size:'xl'
    }
   this.modalRef=this.modalService.open(content,this.modalOptions);
  
    this.modalRef.result.then((result) => {
   
         // this.Asmtdetls(asid);
          this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
     
   
 }
 
 
 private getDismissReason(reason: any): string {
   if (reason === ModalDismissReasons.ESC) {
     return 'by pressing ESC';
   } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
     return 'by clicking on a backdrop';
   } else {
     return  `with: ${reason}`;
   }
 }
 

 onbuselect(id: any) {
  this.buid=id;
  this.getbeds(this.objbed.rmctid,this.objbed.buid);
 }

  onrmcatchange(id: any) {
  this.rmctid=id;
  this.getbeds(this.objbed.rmctid,this.objbed.buid);
  // this.getbeds(id);
 }

  onbedselect(id: any) {
  this.objbed.bdid=id;
 }


  onmemberselectEvent(item) {
//alert('hi');
    console.log('item',item);
   }

   
  onmemberChangeSearch(sertxt) {
    debugger
  

  // this.arflstudent=  this.arrhosstu.filter(user => user.stunm === sertxt.query);

  this.arflstudent= this.arrhosstu.filter(item => {
      // Use includes() for "like" (partial string match) functionality
      const nameMatches = item.stunm.toLowerCase().includes(sertxt.query.toLowerCase());
      // const typeMatches = item.type.toLowerCase().includes(lowerCaseSearchTerm);
      
      // Return true if either property matches the search term
      return nameMatches ; 
    });
  }
 

  
save_allotbed()
{
console.log('saveobj',this.objbed);
  this.fservice.save_allotbed(this.objbed)
      .subscribe(
      result => {
          console.log('SavegenmasDetails', result);
          //this.suppliers = resultArray;
          alert(result.message);
          if(result.status=='Success')
          {
            let localmodref=this.modalRef;
            localmodref.close();
            this.objbed={};
            this.getstudents();

          }
         else
         {

         }
      },
      error =>{ alert('Error While saving...');}
      )
}


}
